export const de = {
    translation: {
        errorCodes: {
            PARSE_ERROR: 'Konnte nicht analysiert werden',
            BAD_REQUEST: 'Ungültige Anfrage',
            INTERNAL_SERVER_ERROR: 'Unerwarteter Serverfehler',
            NOT_IMPLEMENTED: 'Nicht implementiert',
            UNAUTHORIZED: 'Kein gültiger Benutzer',
            FORBIDDEN: 'Zugriff verboten',
            NOT_FOUND: 'Nicht gefunden',
            METHOD_NOT_SUPPORTED: 'Diese Methode wird nicht unterstützt',
            TIMEOUT: 'Zeitüberschreitung aufgetreten',
            CONFLICT: 'Ein Konflikt ist aufgetreten',
            PRECONDITION_FAILED: 'Eine Vorbedingung ist fehlgeschlagen',
            PAYLOAD_TOO_LARGE: 'Die Auslastung ist zu groß',
            UNPROCESSABLE_CONTENT: 'Die Daten können nicht verarbeitet werden',
            TOO_MANY_REQUESTS: 'Zu viele Anfragen',
            CLIENT_CLOSED_REQUEST: 'Der Client hat die Anfrage geschlossen',
        },
        actions: {
            ok: 'OK',
            yes: 'Ja',
            no: 'Nein',
            help: 'Hilfe',
            back: 'Zurück',
            next: 'Weiter',
            create: 'Erstellen',
            createAndSend: 'Erstellen und versenden',
            createNamed: '{{name}} erstellen',
            save: 'Speichern',
            saveDraft: 'Entwurf speichern',
            saveDrafts: 'Entwürfe speichern',
            accept: 'Annehmen',
            cancel: 'Abbrechen',
            close: 'Schließen',
            confirm: 'Bestätigen',
            edit: 'Bearbeiten',
            editDetails: 'Details bearbeiten',
            editSettings: 'Einstellungen',
            add: 'Hinzufügen',
            delete: 'Löschen',
            remove: 'Entfernen',
            replace: 'Ersetzen',
            assign: 'Zuweisen',
            print: 'Drucken',
            download: 'Herunterladen',
            share: 'Teilen',
            send: 'Senden',
            import: 'Importieren',
            export: 'Exportieren',
            archive: 'Archivieren',
            unarchive: 'Wiederherstellen',
            preview: 'Vorschau',
            view: 'Anzeigen',
            viewDetails: 'Details anzeigen',
            clear: 'Zurücksetzen',
            complete: 'Abschließen',
            apply: 'Übernehmen',
            applyChanges: 'Änderungen anwenden',
            submit: 'Abschicken',
            copyToClipboard: 'In Zwischenablage kopieren',
            useUserTimezone: 'Meine Zeitzone verwenden',
            applyFilter: 'Filter anwenden',
            clearFilter: 'Filter entfernen',
            loadMore: 'Mehr laden',
            more: 'Mehr',
            upload: 'Hochladen',
            moveUp: 'Nach oben bewegen',
            moveDown: 'Nach unten bewegen',
            moveLeft: 'Nach links bewegen',
            moveRight: 'Nach rechts bewegen',
            duplicate: 'Duplizieren',
            openInNewTab: 'In neuem Tab öffnen',
            info: 'Info',
            actions: 'Aktionen',
            reject: 'Ablehnen',
            read: 'Gelesen',
            unread: 'Ungelesen',
            email: 'E-Mail',
            applicant: 'Anmelder',
            name: 'Name',
            services: 'Services',
            team: 'Team',
            seat: 'Platz',
            move: 'Verschieben',
            collect: 'Einziehen',
            request: 'Anfordern',
            bookable: 'Buchbar',
            invoice: 'Rechnung',
            message: 'Nachricht',
        },
        misc: {
            sortedBy: 'sortiert nach',
            sortAscending: 'Aufsteigend sortieren',
            sortDescending: 'Absteigend sortieren',
            today: 'Heute',
            calendarWeek: 'KW',
            copiedToClipboard: 'In die Zwischenablage kopiert',
            tagsEdit: 'Tippen zum hinzufügen',
            tagsReadOnly: 'Keine Tags verfügbar',
            required: 'Erforderlich',
            notAvailable: 'Nicht verfügbar',
            optional: 'Optional',
            all: 'Alle',
            none: 'Keine',
            of: 'von',
            selected: 'ausgewählt',
            allSelected: 'Alle ausgewählt',
        },
        components: {
            markdown: {
                showMoreCode: 'Mehr anzeigen',
            },
            label: {
                showHint: 'Hinweis anzeigen',
            },
            sidebar: {
                title: 'Seitenleiste',
                description: 'Zeigt die mobile Seitenleiste.',
                toggle: 'Seitenleiste umschalten',
            },
            commandDialog: {
                title: 'Befehlspalette',
                description: 'Suche nach einem Befehl',
            },
            noMandate: {
                title: 'Mandant wählen',
                message: 'Wähle einen Mandanten, um fortzufahren.',
            },
            imageGallery: {
                open: 'Bildergalerie öffnen',
            },
            table: {
                showAllValues: 'Alle Werte anzeigen',
                showDetails: 'Details anzeigen',
                hideDetails: 'Details ausblenden',
                selectRow: 'Zeile auswählen',
                selectAll: 'Alle auswählen',
                clearSelection: 'Auswahl aufheben',
                sort: 'Sortieren',
                sortBy: 'Sortieren: {{column}}',
                sortAscending: 'Aufsteigend sortieren',
                sortDescending: 'Absteigend sortieren',
            },
            addressForm: {
                addressComplete: {
                    defaultPlaceholder: 'Adresse für Vervollständigung eingeben',
                    noResults: 'Keine Adressen gefunden. Suche nach einer anderen Adresse oder gib sie manuell ein.',
                    searchError: 'Die Adresssuche ist fehlgeschlagen. Versuche es erneut oder gib die Adresse manuell ein.',
                    enterManually: 'Adresse manuell eingeben',
                },
                addressFields: {
                    country: 'Land',
                    zip: 'Postleitzahl',
                    city: 'Stadt',
                    state: 'Bundesstaat',
                    detailsRecipient1: 'weitere Empfängerangabe (z.B. Firma oder c/o)',
                    detailsRecipient2: 'weitere Empfängerangabe (z.B. Stockwerk)',
                    detailsPlace1: 'weitere Ortsangabe (z.B. Gebäude)',
                    detailsPlace2: 'weitere Ortsangabe (z.B. Eingang)',
                    addDetails: ' Zusätzliche Adresszeilen hinzufügen',
                    removeDetails: ' Zusätzliche Adresszeilen entfernen',
                    addressLine: 'Strasse mit Hausnummer oder Postfach',
                },
            },
            simpleFormView: {
                addItemCaption: 'Eintrag hinzufügen',
                addItemCaptionMore: 'Weiteren Eintrag hinzufügen',
                itemCaption: 'Eintrag',
                selectMinMaxChoices: 'Wähle mindestens {{min}} und maximal {{max}}',
                selectMinChoices: 'Wähle mindestens {{min}}',
                selectMaxChoices: 'Wähle maximal {{max}}',
                acceptTermsStart: 'Ich bestätige, die',
                acceptTermsLink: 'Allgemeinen Geschäftsbedingungen',
                acceptTermsEnd: 'zu akzeptieren',
                acceptPrivacyStart: 'Ich stimme den',
                acceptPrivacyLink: 'Datenschutzbestimmungen',
                acceptPrivacyEnd: 'zu',
                acceptAgreement: 'Zustimmung',
                noTermsOrPrivacy: 'Keine Geschäftsbedingungen oder Datenschutzbestimmungen wurden bereitgestellt',
                noSelectableItems: 'Keine {{groupName}} verfügbar',
                noPaymentMethods: 'Keine Zahlungsmethoden verfügbar',
                file: { addFile: 'Datei hinzufügen' },
                signature: {
                    loading: 'Signaturfeld wird geladen...',
                    draw: 'Zeichnen',
                    upload: 'Hochladen',
                    uploadedPreview: 'Vorschau der hochgeladenen Signatur',
                    undo: 'Rückgängig',
                    clear: 'Leeren',
                },
                paymentMethod: {
                    payVia: 'Bezahlen per {{paymentMethodType}}',
                    paymentMode: {
                        oneTime: 'Einmalige Zahlung',
                        recurring: 'Wiederkehrende Zahlung',
                    },
                    paymentMethodType: {
                        sepaDirectDebit: 'SEPA-Lastschrift',
                        sepaCreditTransfer: 'SEPA-Überweisung',
                        cash: 'Barzahlung',
                        online: 'Online',
                        paypal: 'PayPal',
                    },
                    sepaDirectDebit: {
                        iban: 'IBAN',
                        bic: 'BIC',
                        creditor: 'Gläubiger',
                        creditorIdentifier: 'Gläubiger-ID',
                        terms: {
                            oneTime:
                                'Ich ermächtige "{{organizationName}}", den fälligen Betrag einmalig von meinem Konto per SEPA-Basislastschrift einzuziehen. Zugleich weise ich mein Kreditinstitut an, die von "{{organizationName}}" auf mein Konto gezogene Lastschrift einzulösen. Ich kann innerhalb von acht Wochen ab dem Belastungsdatum die Erstattung des belasteten Betrags verlangen. Es gelten die mit meinem Kreditinstitut vereinbarten Bedingungen.',
                            recurring:
                                'Ich ermächtige "{{organizationName}}", fällige wiederkehrende Zahlungen von meinem Konto per SEPA-Basislastschrift einzuziehen. Zugleich weise ich mein Kreditinstitut an, die von "{{organizationName}}" auf mein Konto gezogenen Lastschriften einzulösen. Ich kann innerhalb von acht Wochen ab dem jeweiligen Belastungsdatum die Erstattung des belasteten Betrags verlangen. Es gelten die mit meinem Kreditinstitut vereinbarten Bedingungen.',
                        },
                        mandateAcceptance: {
                            oneTime:
                                'Ich erteile "{{organizationName}}" das oben genannte SEPA-Lastschriftmandat für diese einmalige Zahlung.',
                            recurring:
                                'Ich erteile "{{organizationName}}" das oben genannte SEPA-Lastschriftmandat für wiederkehrende Zahlungen.',
                        },
                    },
                },
            },
            control: {
                phoneInput: {
                    invalidPhoneNumber: 'Ungültige Telefonnumer für das gewählte Land',
                    noMatchingCountry: 'Kein passendes Land gefunden',
                },
                passwordInput: {
                    show: 'Passwort anzeigen',
                    hide: 'Passwort ausblenden',
                },
                searchInput: { placeholder: 'Suchen' },
                combobox: {
                    createOption: '{{query}} hinzufügen',
                    noOptions: 'Es konnten keine Optionen gefunden werden',
                    loading: 'Lädt ...',
                    loadingMore: 'Lädt weitere ...',
                    placeholder: 'Option auswählen',
                },
            },
            misc: {
                propertyFilterEditor: {
                    favorites: 'Favoriten',
                    groupActions: 'Gruppenaktionen',
                    addProperty: 'Eigenschaft zur Gruppe hinzufügen',
                    duplicateGroup: 'Gruppe duplizieren',
                    deleteGroup: 'Gruppe löschen',
                    configureProperty: 'Eigenschaft konfigurieren',
                    selectValue: 'Wert auswählen',
                    selectOperator: 'Operator auswählen',
                    addFilter: 'Neuer Filter',
                    dynamicProperty: 'Dynamische Eigenschaft',
                    missingProperty: 'Ungültige Eigenschaft',
                    missingSourceProperty: 'Ungültige Quelleigenschaft',
                    removeProperty: 'Eigenschaft entfernen',
                    selectProperty: 'Eigenschaft auswählen',
                },
                dateSelector: {
                    rangePreset: {
                        action: 'Schnellbereiche',
                        currentMonth: 'Aktueller Monat',
                        currentMonthCompact: 'Monat',
                        currentQuarter: 'Aktuelles Quartal',
                        currentQuarterCompact: 'Quartal',
                        currentYear: 'Aktuelles Jahr',
                        currentYearCompact: 'Jahr',
                        previousYear: 'Vorjahr',
                        previousYearCompact: 'Vorjahr',
                    },
                },
            },
            dialog: { confirm: { prefix: 'Bitte bestätige die Aktion, indem du den folgenden Text eingibst:' } },
            form: {
                submitError: 'Beim Absenden ist ein Fehler aufgetreten, bitte versuche es erneut',
                submitSuccess: 'Änderungen erfolgreich gespeichert',
                deleteError: 'Beim Löschen ist ein Fehler aufgetreten, bitte versuche es erneut',
                deleteSuccess: 'Erfolgreich gelöscht',
            },
            ui: {
                dateInput: {
                    invalidDateFormat: 'Ungültiges Datumsformat',
                    dateBeforeMinDate: 'Das Datum liegt vor dem zulässigen Mindestdatum',
                    dateAfterMaxDate: 'Das Datum liegt nach dem zulässigen Höchstdatum',
                },
                datePicker: { selectDate: 'Datum auswählen' },
                numberInput: { decrease: 'Verringern', increase: 'Erhöhen' },
                richTextEditor: {
                    editorPlaceholder: 'Tippe "/" für weitere Aktionen oder schreibe etwas',
                    toolbar: {
                        insertTag: 'Platzhalter',
                        moreActions: 'Weitere Aktionen',
                        bold: 'Fett',
                        italic: 'Kursiv',
                        strikethrough: 'Durchgestrichen',
                        highlight: 'Hervorheben',
                        link: 'Link einfügen',
                    },
                    tags: {
                        search: 'Tags suchen',
                        empty: 'Keine Tags gefunden',
                        sample: 'Beispiel',
                        ungrouped: 'Allgemein',
                    },
                    groups: { inline: 'Formatierung', text: 'Text', lists: 'Listen', other: 'Sonstiges' },
                    blocks: {
                        h1: 'Überschrift 1',
                        h2: 'Überschrift 2',
                        h3: 'Überschrift 3',
                        quote: 'Zitat',
                        divider: 'Trenner',
                        bulletList: 'Aufzählungsliste',
                        orderedList: 'Nummerierte Liste',
                        taskList: 'Aufgabenliste',
                        codeBlock: 'Codeblock',
                        table: 'Tabelle',
                        image: 'Bild',
                    },
                    errors: {
                        tagsNotAllowed: 'Die folgenden Tags sind nicht erlaubt: {{tags}}',
                        minLength: 'Bitte gib mindestens {{length}} Zeichen ein',
                        maxLength: 'Bitte gib höchstens {{length}} Zeichen ein',
                    },
                },
                timePicker: { selectTime: 'Uhrzeit auswählen' },
            },
            fileStorageResourceSelect: {
                select: 'Wähle Datei',
                change: 'Ändere Datei',
                clear: 'Entfernen',
                download: 'Herunterladen',
                info: { maxFileSizeLabel: 'Maximale Dateigröße', allowedTypesLabel: 'Erlaubte Dateitypen' },
                dropzone: {
                    emptyTitle: 'Datei hier hineinziehen',
                    emptyInfo: 'Oder klicken, um eine Datei auszuwählen',
                    replaceTitle: 'Datei hier hineinziehen, um sie zu ersetzen',
                    replaceInfo: 'Oder klicken, um eine andere Datei auszuwählen',
                },
            },
            imageStorageResourceSelect: { select: 'Wähle Bild', change: 'Bild ändern', clear: 'Entfernen' },
            useUpload: {
                fileTooLarge: { title: 'Datei zu groß', message: 'Die angegebene Datei ist zu groß zum Hochladen' },
                uploadError: {
                    title: 'Hochladen fehlgeschlagen',
                    message: 'Beim Hochladen ist ein Fehler aufgetreten, bitte versuche es erneut',
                },
                progress: 'Datei wird hochgeladen ({{progress}}%)...',
            },
            actorName: { currentUser: 'Du', deletedUser: 'Gelöschter Benutzer', deletedContact: 'Gelöschter Kontakt' },
            pageWorkspace: {
                tabs: {
                    label: 'Geöffnete Seiten',
                    scrollLeft: 'Tabs nach links scrollen',
                    scrollRight: 'Tabs nach rechts scrollen',
                    closeTab: '{{name}} schließen',
                    reorderInstructions:
                        'Mit Alt+Umschalt+Links oder Rechts verschiebst du diesen Tab. Mit Entf schließt du ihn.',
                    moving: '{{name}} wird verschoben.',
                    moved: '{{name}} wurde an Position {{position}} verschoben.',
                    moveCancelled: 'Verschieben des Tabs abgebrochen.',
                },
                openAsPage: 'Als Seite öffnen',
                discardChanges: 'Möchtest du deine ungespeicherten Änderungen verwerfen?',
                loadError: 'Diese Seite konnte nicht geladen werden',
                loading: 'Seite wird geladen',
                retry: 'Erneut versuchen',
                retryRefresh: 'Liste aktualisieren',
                refreshError:
                    'Deine Änderungen wurden gespeichert, aber die Liste konnte nicht aktualisiert werden. Wähle „Liste aktualisieren“, um es erneut zu versuchen.',
            },
            page: {
                toolbar: {
                    filters: 'Filter',
                },
                actions: {
                    toggleAppSidebar: 'App-Seitenleiste umschalten',
                    togglePageSidebar: 'Seiten-Seitenleiste umschalten',
                    copyPageUrl: 'Seiten-URL kopieren',
                    openInNewWindow: 'In neuem Fenster öffnen',
                    copyPageUrlSuccess: 'Seiten-URL kopiert',
                    pageOptions: 'Seitenoptionen',
                },
                selection: {
                    clear: 'Auswahl aufheben',
                    more: 'Weitere Aktionen',
                },
            },
            amountModifierInput: { plus: 'Plus', minus: 'Minus', set: 'Als Betrag', percentage: 'Prozent' },
            emptyState: {
                noAccess: {
                    title: 'Kein Zugriff',
                    subtitle: 'Du hast keinen Zugriff auf diese Funktion',
                    requiredPermissions: 'Erforderliche Berechtigungen',
                },
            },
            fileUpload: {
                tooBig: {
                    title: 'Einige Datei(en) sind zu groß',
                    message: 'Eine oder mehrere Dateien überschreiten die erlaubte Maximalgröße von {{maxSize}}',
                },
                uploadTitle: 'Wird hochgeladen',
                dropFilesTitle: 'Datei(en) ablegen',
                dropHereTitle: 'Datei hier ablegen oder',
                dropHereMultipleTitle: 'Dateien hier ablegen oder',
                selectFiles: 'hier klicken, um diese manuell auszuwählen',
                format: 'Format',
                size: 'Größe',
            },
            pagination: {
                label: 'Seitennavigation',
                previousPage: 'Vorherige Seite',
                nextPage: 'Nächste Seite',
                show: 'Zeige {{fromCount, int}} bis {{toCount, int}}',
                total: 'von insgesamt {{count, int}} an',
            },
            paymentMethod: {
                payVia: 'Bezahlen per {{paymentMethod}}',
                label: 'Zahlungsmethode',
                online: {
                    terms: 'Du erhältst nach deiner Buchung einen Link mit Zahlungsanweisungen. Bitte führe die Zahlung bis zum {{dueDate}} durch.',
                    cardBrandNotSupported: 'Dieser Kartentype wird nicht unterstützt, bitte verwende eine andere Karte',
                    paypal: { name: 'Mit PayPal bezahlen', methodName: 'PayPal' },
                    stripe: {
                        name: 'Online bezahlen',
                        methodName: 'Online-Zahlung',
                        status: {
                            notAvailable: 'Online-Zahlung ist nicht aktiviert',
                            error: 'Es ist ein Fehler beim initialisieren der Online-Zahlung aufgetreten',
                        },
                    },
                    amountTooLow:
                        'Der Betrag ist zu niedrig, um verarbeitet zu werden. Der von dieser Zahlungsmethode unterstützte Mindestbetrag beträgt {{amount}}.',
                },
                sepaDirectDebit: {
                    name: 'Bezahlen per Lastschrift',
                    methodName: 'Lastschrift',
                    terms: 'Mit der Angabe der Zahlungsinformationen und der Bestätigung der Buchung ermächtigen Sie (A) {{organizationName}}, diese Zahlung von Ihrem Konto per Lastschrift einzuziehen. Gleichzeitig (B) weisen Sie Ihre Bank an, Ihr Konto gemäß diesen Anweisungen zu belasten. Sie haben Anspruch auf eine Erstattung durch Ihre Bank gemäß den mit Ihrer Bank vereinbarten Bedingungen. Sie können innerhalb von acht Wochen, beginnend mit dem Belastungsdatum, die Erstattung des belasteten Betrages verlangen. Es gelten dabei die mit Ihrem Kreditinstitut vereinbarten Bedingungen.',
                },
                sepaCreditTransfer: {
                    name: 'Bezahlen per Überweisung',
                    methodName: 'Überweisung',
                    terms: 'Du erhältst eine Quittung mit Zahlungsinformationen, über die du das Geld nach deiner Buchung überweisen kannst.',
                },
                cash: { name: 'Bar bezahlen', methodName: 'Barzahlung' },
            },
            useSelectFile: {
                tooBig: {
                    title: 'Einige Datei(en) sind zu groß',
                    message: 'Ein oder mehrere Dateien überschreiten die maximal erlaubte Größe von {{maxSize}}',
                },
            },
        },
        app: {
            error: {
                title: 'Hoppla! Hier stimmt etwas nicht...',
                event: 'Event: {{event}}',
                goBack: 'Zurück',
                or: 'oder',
                support: 'Kontaktiere unser Support-Team',
            },
        },
        donation: {
            form: {
                amountField: {
                    customAmount: 'Anderer Betrag',
                },
                paymentMethodField: {
                    noPaymentMethodAvailable: 'Für dieses Formular ist keine Zahlungsmethode verfügbar.',
                    sepaCreditTransferTerms: 'Du erhältst die Kontodaten für deine Überweisung nach dem Absenden.',
                },
                summaryField: {
                    coverFees: 'Ich übernehme {{amount}} für die Kosten der Zahlung',
                    total: 'Deine Spende',
                },
            },
        },
        booking: {
            cancelRefund: {
                and: 'und',
                buyer: {
                    priceLead: 'Du erhältst',
                    pricePointsTail: 'Punkte.',
                    pointsTail: 'Punkte.',
                    none: 'Du erhältst keine Erstattung.',
                },
                issuer: {
                    pricePrefix: 'Es werden',
                    priceTail: 'erstattet.',
                    pricePointsTail: 'Punkte erstattet.',
                    pointsTail: 'Punkte erstattet.',
                    none: 'Es wird keine Erstattung ausgezahlt.',
                },
            },
            editor: {
                buyerEditor: {
                    title: {
                        withBookingNumber: 'Buchung “{{bookingNumber}}” bearbeiten',
                        withoutBookingNumber: 'Buchung bearbeiten',
                    },
                    description:
                        'Wenn es zu dieser Buchung Belege gibt, werden sie automatisch aktualisiert. Die aktualisierten Belege werden nicht automatisch verschickt. Du kannst sie bei Bedarf später manuell senden.',
                    name: 'Name',
                    phone: 'Telefonnummer',
                    email: 'E-Mail-Adresse',
                    emailInfo:
                        'Falls die E-Mailadresse geändert wird, werden alle zuvor fehlgeschlagenen E-Mails erneut versendet.',
                    personName: 'Name der Person',
                    address: 'Adresse',
                },
                servicesEditor: {
                    title: 'Services bearbeiten',
                    description: 'Du kannst die Services für diese Buchung anpassen',
                    removedServices: {
                        title: 'Entfernte Services',
                        refundInfo:
                            'Die folgenden Services werden erstattet. Du kannst den Erstattungsbetrag für jeden Service anpassen oder auf eine Erstattung verzichten.',
                        refund: 'Erstatten',
                        total: 'Zu erstatten',
                        reset: 'Auf ursprünglichen Betrag zurücksetzen',
                    },
                    addedServices: {
                        title: 'Hinzugefügte Services',
                        chargeInfo:
                            'Die folgenden Services werden in einem neuen Beleg abgerechnet. Du kannst auch wählen, Services nicht zu berechnen.',
                        charge: 'Berechnen',
                        total: 'Zu berechnen',
                    },
                    confirm: {
                        title: 'Änderungen bestätigen',
                        message:
                            'Bist du sicher, dass du die Änderungen durchführen möchtest? Dies kann nicht rückgängig gemacht werden.\n' +
                            '\n' +
                            'Zu erstatten: {{amountToRefund}}\n' +
                            'Zu berechnen: {{amountToCharge}}',
                        confirm: 'Bestätigen',
                        cancel: 'Abbrechen',
                    },
                },
            },
            event: { attendeeEditor: { title: 'Teilnehmer bearbeiten' } },
            resource: {
                form: {
                    addSlot: 'Zeitslot hinzufügen',
                    removeSlot: 'Zeitslot entfernen',
                    addQuantity: 'Menge erhöhen',
                    removeQuantity: 'Menge verringern',
                },
            },
        },
        developer: {
            app: {
                host: {
                    form: { submitError: 'Das Formular konnte nicht abgeschickt werden.' },
                    widget: { loadError: 'Widget konnte nicht geladen werden.' },
                },
            },
        },
        routes: { errorPage: { goBack: 'Zurück' } },
        utils: {
            booking: {
                event: {
                    recurringSeriesFutureDatesInfo: {
                        label: 'Weitere Termine stehen noch nicht fest.',
                        description:
                            'Diese Serie wird über die derzeit angezeigten Termine hinaus fortgesetzt. Weitere Termine werden im Verlauf der Serie automatisch hinzugefügt.',
                    },
                    eventBadges: {
                        ended: 'Beendet',
                        canceled: 'Abgesagt',
                        blockedResource: 'Gesperrt',
                        blockedCalendar: 'Gesperrt',
                        available: 'Verfügbar',
                        waitlist: 'Warteliste',
                        seatsAvailable_zero: 'Ausgebucht',
                        seatsAvailable_one: 'Ein Platz verfügbar',
                        seatsAvailable_other: '{{count, number}} Plätze verfügbar',
                        seatsAvailableMany: 'Verfügbar',
                        availableFrom: 'Demnächst',
                        bookableFrom: 'Buchbar ab {{date}}',
                        availableTo: 'Geschlossen',
                        notAvailable: 'Geschlossen',
                    },
                    simpleForm: {
                        ticketsField: {
                            membership: 'Mitgliedschaftsinformationen',
                            attendeeName: 'Teilnehmer Name',
                            attendeePlaceholder: 'Max Mustermann',
                            services: 'Zusätzliche Services',
                            ticket: 'Ticket',
                        },
                        summaryField: {
                            eventSeries: '({{count, number}} von {{total, number}} Events)',
                            anonymous: 'Anonym',
                            tickets_one: '{{rateName}} ({{attendeeName}}) - {{count, number}} Ticket',
                            tickets_other: '{{rateName}} ({{attendeeName}}) - {{count, number}} Tickets',
                            waitlisted: 'Auf Warteliste',
                            confirmationRequired: 'Die Buchung muss manuell von unserem Team bestätigt werden',
                        },
                        selectableRateField: {
                            contactMemberTicket:
                                'Für jeden Tarif liefert der ausgewählte Kontakt die Mitgliedschaft für ein Ticket, für das eine eigene Mitgliedschaft erforderlich ist.',
                            noRate: 'Tarif nicht gefunden',
                            removeQuantity: 'Menge reduzieren',
                            addQuantity: 'Menge erhöhen',
                            quantity: 'Lege fest, wie viele Tickets für diesen Tarif gebucht werden',
                            tickets: 'Tickets',
                            price_one: 'Ticket ({{price}})',
                            price_other: 'Tickets ({{price}})',
                            points_one: 'Tickets ({{points}} Pkt.)',
                            points_other: 'Tickets ({{points}} Pkt.)',
                        },
                    },
                },
                simpleForm: {
                    rateField: {
                        selectRate: 'Wähle einen Tarif',
                        selectRateRequired: 'Bitte wähle einen Tarif aus',
                        membersOnly: 'Nur für Mitglieder',
                        selectRateVariant: 'Wähle eine Variante für diesen Tarif',
                        punchCardPurchsable: 'Punktekarte kann gekauft werden',
                        punchCard: 'Punktekarte',
                        quantity: 'Mindestens {{quantity}} Tickets',
                        attendee: 'Teilnehmer {{index}}',
                        attendeeName: 'Vollständiger Name',
                        attendeeNamePlaceholder: 'Max Mustermann',
                        availableStatus: {
                            soldOut: 'Ausverkauft',
                            notYetAvailable: 'Bald verfügbar',
                            noLongerAvailable: 'Abgelaufen',
                            waitlist: 'Auf Warteliste',
                        },
                        punchCardSelector: {
                            info: 'Gib eine existierende Kartennummer von {{name}} an oder kaufe eine neue Punktekarte',
                            existingCard: 'Vorhandene Karte nutzen',
                            buyNewCard: 'Neue Karte für {{price}} kaufen',
                            useNewlyBoughtCard: 'Gekaufte Stempelkarte verwenden',
                        },
                    },
                    servicesField: {
                        noService: 'Kein optionaler Service',
                        selectionLabel: 'Wähle einen optionalen Service',
                        selectServices: 'Weitere Services auswählen',
                        requiredServices: 'Erforderliche Services',
                        selectMinMaxOptions: 'Wähle mindestens {{min}} und maximal {{max}}',
                        selectMinOptions: 'Wähle mindestens {{min}}',
                        selectMaxOptions: 'Wähle maximal {{max}}',
                        availableStatus: { soldOut: 'Ausverkauft' },
                        serviceChargedOnce: 'Nur einmal abrechnen',
                        serviceChargedTitle:
                            'Nur einmal für alle Tickets abrechnen. Hinweis: Dieser Service ist nicht erstattungsfähig.',
                    },
                    summaryField: {
                        priceSubTotal: 'Zwischensumme',
                        discountCode: 'Rabattcode',
                        price: 'Gesamtsumme',
                        points: 'Gesamtpunkte',
                        priceToPay: 'Jetzt zu bezahlen',
                        pointsToUse: 'Punkte jetzt fällig',
                        paymentDueBy: 'Zahlung fällig bis',
                    },
                    discountField: { inputPlaceholder: 'Gib einen Rabattcode ein', applyCode: 'Code anwenden' },
                    refundPoliciesField: {
                        title: 'Stornierungs- und Erstattungsregeln',
                        refundLabel: 'Bei Stornierung bis {{time}} vor Beginn {{refunds}}',
                        refundsBoth: '{{priceRefund}} oder {{pointRefund}}',
                        priceRefund: {
                            none: 'wird der Preis nicht erstattet',
                            amount: 'werden {{amount}} als Stornierungsgebühr fällig',
                            '%': 'werden {{percentage}}% vom bezahlten Preis erstattet',
                        },
                        pointRefund: {
                            none: 'werden Punkte nicht erstattet',
                            amount: 'werden {{amount}} Punkte als Stornierungsgebühr fällig',
                            '%': 'werden {{percentage}}% der genutzten Punkte erstattet',
                        },
                        noRefund: 'Keine Erstattung',
                    },
                    paymentMethodField: {
                        noPaymentMethodAailable:
                            'Es wurden noch keine Zahlungsmethoden für dieses Event verfügbar gemacht',
                    },
                    memberInfo: {
                        birthdatePart: { day: 'Tag', month: 'Monat', year: 'Jahr' },
                        info: 'Bitte gib weitere Infos an um dich als Mitglied zu identifizieren',
                        perTicketInfo:
                            'Bitte gib weitere Infos an, um dich für dieses Ticket als Mitglied zu identifizieren',
                        birthdate: 'Geburtsdatum',
                        membershipNumber: 'Mitgliedsnummer',
                        birthdateInfo: 'Wenn Sie für eine Organisation buchen lassen Sie das Geburtsdatum einfach leer',
                        loadingMemberDetails: 'Mitgliedsdaten werden geladen',
                        validatingMembershipNumber: 'Mitgliedsnummer wird überprüft',
                        membershipNumberValid: 'Gültige Mitgliedsnummer',
                    },
                },
            },
            reports: { noData: 'Keine Daten zum Exportieren vorhanden' },
            webPush: {
                granted: {
                    title: 'Browser-Push-Benachrichtigungen sind erlaubt',
                },
                default: {
                    title: 'Browser-Push-Benachrichtigungen sind nicht aktiviert',
                },
                denied: {
                    title: 'Browser-Push-Benachrichtigungen sind blockiert',
                },
                unsupported: {
                    title: 'Browser-Push-Benachrichtigungen werden nicht unterstützt',
                },
                permissionPrompt: {
                    dialogTitle: 'Browser-Push-Benachrichtigungen aktivieren?',
                    dialogDescription:
                        'Campai kann Benachrichtigungen über diesen Browser senden. Wenn du Ja wählst, fragt dein Browser nach der Berechtigung. Wenn die Browser-Abfrage nicht erscheint, prüfe deine Browser-Einstellungen.',
                    confirm: 'Ja, aktivieren',
                    cancel: 'Nicht jetzt',
                },
                permissionDenied: {
                    dialogTitle: 'Browser-Push-Benachrichtigungen sind blockiert',
                    dialogDescription:
                        'Du hast Push-Benachrichtigungen für diesen Browser abgelehnt. Aktiviere Benachrichtigungen für diese Seite in deinen Browser-Einstellungen, wenn du sie hier erhalten möchtest.',
                },
                permissionUnsupported: {
                    dialogTitle: 'Browser-Push-Benachrichtigungen werden nicht unterstützt',
                    dialogDescription:
                        'Dieser Browser unterstützt Push-Benachrichtigungen für diese Seite nicht. Verwende einen unterstützten Browser, wenn du sie hier erhalten möchtest.',
                },
            },
        },
    },
}
